module.exports = __webpack_public_path__ + "img/33 te.7c4de1bc.jpg";